import { applyPromotionsToCart } from "@/services/promotion-service";

export { applyPromotionsToCart };

export default { applyPromotionsToCart };
